export const base = {
  fonts: {
    heading: "'Poppins', sans-serif",
    body: "'Poppins', sans-serif",
    logo: "'Suez One', serif",
    mono: "'Roboto Mono', monospace",
  },
  borderRadius: '4px',
  transition: '250ms',
  shadow: ['-10px 0px 30px -15px #333'],
  maxWidth: '1000px',
};

export const main = {
  primary: '#0f7bf1',
  secondary: '#FAEAFF',
  heading: '#333',
  text: '#333333',
  hoverPrimary: '#429CFD',
  hoverSecondary: '#E5F2FF',
};

const size = {
  mobile: '600px',
  tablet: '768px',
  laptop: '980px',
  desktop: '1440',
};

export const device = {
  mobile: `(max-width: ${size.mobile})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  desktop: `(max-width: ${size.desktop})`,
};
